module.exports = __webpack_public_path__ + "img/icon_guanyuwomen_qukuailian@3x.f191f921.png";